<template>
  <div :id="mobilePcif ? 'app' : 'appMobile'">
    <!-- pc端 -->
    <!-- 背景 -->

    <div class="headerbeg" v-if="mobilePcif"></div>

    <div class="head_py" v-if="mobilePcif">
      <div class="head_center">
        <h1 class="head_logo">
          <!-- <img src="@/components/images/header.png" alt=""> -->
          <img src="@/components/images/puyang_logo.png" alt="">
        </h1>
        <div class="el-tabs__header">
          <router-link class="navigation_title" :class="switchClass == 1 ? 'navigation_title_if' : ''"
            @click.native="outTag(1, null)" to="/">首页</router-link>
          <div v-for="(item, index) in columnList.slice(0, 9)" :key="index">
            <router-link class="navigation_title" @click.native="outTag(index + 2, item)"
              :class="switchClass == index + 2 ? 'navigation_title_if' : ''"
              :to="{ path: '/announphones', query: { columnId: item.columnId, title: item.name } }">{{ item.name
              }}</router-link>
          </div>
          <el-dropdown trigger="click" class="dropdown" placement="bottom-start">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon--right" style="color:#fff"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in columnList.slice(9, columnList.length)" :key="index"
                :class="{ 'selected': status == item.columnId }">
                <router-link class="navigation_link" @click.native="outTag(index + 11, item)"
                  :to="{ path: '/announphones', query: { columnId: item.columnId, title: item.name } }">{{ item.name
                  }}</router-link>
              </el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>
          <!-- <router-link class="navigation_title" :class="switchClass == 2 ? 'navigation_title_if' :''" @click.native="outTag(2)" to="/alerts">时政快讯</router-link>
            <router-link class="navigation_title" :class="switchClass == 3 ? 'navigation_title_if' :''" @click.native="outTag(3)" to="/announphones">手机报</router-link>
            <router-link class="navigation_title" :class="switchClass == 4 ? 'navigation_title_if' :''" @click.native="outTag(4)" to="/announcement">公示公告</router-link>
            <router-link class="navigation_title" :class="switchClass == 5 ? 'navigation_title_if' :''" @click.native="outTag(5)" to="/importantnews">濮阳要闻</router-link>
            <router-link class="navigation_title" :class="switchClass == 6 ? 'navigation_title_if' :''" @click.native="outTag(6)" to="/comprehensivenews">综合新闻</router-link>
            <router-link class="navigation_title" :class="switchClass == 7 ? 'navigation_title_if' :''" @click.native="outTag(7)" to="/longxiangnews">龙乡新闻</router-link>
            <router-link class="navigation_title" :class="switchClass == 8 ? 'navigation_title_if' :''" @click.native="outTag(8)" to="/happyErShiDa">喜迎二11十大</router-link> -->
        </div>
      </div>
    </div>


    <!-- 移动端 -->
    <div class="head_app" v-if="!mobilePcif">
      <div class="bounced_app">
        <div class="head_top_app">
          <h1 class="logo_app" @click="btnPage()">
            <!-- <img src="@/components/images/puyang_logo.png" alt=""> -->
          </h1>
          <div class="head_right_app" style="padding-top: 33px;">
            <i class="el-icon-search head_retrieve" @click="retrieveAppBtn"></i>
            <i class="el-icon-menu head_more" @click="moreAppBtn"></i>
          </div>
        </div>
        <mt-popup class="more_bounced_app" v-model="popupVisible" position="top">
          <MormComponent></MormComponent>
        </mt-popup>
        <mt-popup class="more_bounced_app" v-model="popupVisibleIf" position="top">
          <RetrieveBounced></RetrieveBounced>
        </mt-popup>
      </div>
      <router-view />
      <!-- <AppModule></AppModule> -->

      <BottomAppContent></BottomAppContent>
    </div>

    <!-- pc端底部 -->

    <router-view v-if="mobilePcif" />
    <FriendshipLink v-if="mobilePcif && botLinkIf"></FriendshipLink>
    <BottomContent v-if="mobilePcif"></BottomContent>

  </div>
</template>

<script>
import { columnList, getColumnByParentId,generateSign } from '@/api/index'
import Bus from '@/Bus'
// pc端
import Homepage from '@/components/homepage/index'
// 列表
import ContentList from '@/components/contentList/index'
// 详情页
import Detailstitle from '@/components/details/index'
// 底部
import FriendshipLink from '@/components/homepage/components/friendshipLink'
import BottomContent from '@/components/homepage/components/bottomContent'

// 移动端
import AppModule from '@/components/appModule/index'
import MormComponent from '@/components/appModule/bouncedMormApp/mormComponent'
import RetrieveBounced from '@/components/appModule/bouncedMormApp/retrieveBounced'
import BottomAppContent from '@/components/appModule/bouncedMormApp/bottomAppContent'


export default {
  name: 'App',
  data() {
    return {
      jumpRouting: true,
      botLinkIf: false,
      mobilePcif: false,
      switchClass: 1,
      columnList: [],
      status: '',
      // 移动端
      popupVisible: false,
      popupVisibleIf: false,
    }
  },
  created() {
    this.projectObtain()
    Bus.$on("stateListShoot", val => {
      this.popupVisibleIf = val
      this.popupVisible = val
    });
    Bus.$on("jumpRouting", val => {
      this.jumpRouting = val
    });
    Bus.$on("botLink", val => {
      this.botLinkIf = val
    });
    console.log(this.$route.query.title, 'lllll')
    // let title = this.$route.query.title
    // this.columnList


    // if(title == '时政快讯'){
    //   this.switchClass = 2
    // }else if(title == '手机报'){
    //   this.switchClass = 3
    // }else if(title == '公示公告'){
    //   this.switchClass = 4
    // }else if( title == '濮阳要闻'){
    //   this.switchClass = 5
    // }else if( title == '综合新闻'){
    //   this.switchClass = 6
    // }else if( title == '龙乡新闻'){
    //   this.switchClass = 7
    // }else if( title == '喜迎二十大'){
    //   this.switchClass = 8
    // }
  },
  components: {
    // pc端
    Homepage,
    // 列表
    Detailstitle,
    // 详情
    ContentList,
    // 底部
    FriendshipLink,
    BottomContent,


    // 移动端
    AppModule,
    MormComponent,
    RetrieveBounced,
    BottomAppContent

  },
  // mounted() {
  //   if (this._isMobile()) {
  //     const url = window.location.origin + '/#/listDetailsApp?' + window.location.hash.split('?')[1] + '&typeNum=1'
  //     if(/\/details/.test(window.location.href)) {
  //       window.location.href = url
  //     }else {
  //       this.$router.replace('/m_index')
  //     }
  //   } else {
  //     this.mobilePcif = true
  //   }
  //   //  window.addEventListener('scroll', this.scrollTop)
  //   // if (this._isMobile()) {
  //   //   this.$router.replace('/m_index');
  //   //   // console.log('details',this.$route)
  //   //   // if(this.$route.path=='')
  //   // } else {

  //   //   this.mobilePcif = true
  //   // }
  // },
  mounted() {
    // console.log(`output->`,generateSign())
    if (this._isMobile()) {
      if (/\/details/.test(window.location.href)) {
        let url = this.removeURLParameter(window.location.href, 'typeNum')
        url = url.split('?')[0].split('details')[0] + 'listDetailsApp?' + url.split('?')[1] + '&typeNum=1'
        window.location.href = url
      } else if (/\/listDetailsApp/.test(window.location.href)) {
        return
      } else {
        this.$router.replace('/m_index')
      }
    } else {
      if (/\/listDetailsApp/.test(window.location.href)) {
        let url = this.removeURLParameter(window.location.href, 'typeNum')
        url = url.split('?')[0].split('listDetailsApp')[0] + 'details?' + url.split('?')[1] + '&typeNum=2'
        window.location.href = url
      }
      this.mobilePcif = true
    }
  },
  methods: {
    removeURLParameter(url, parameter) { // 删除url 参数
      var urlparts = url.split('?');
      if (urlparts.length >= 2) {
        //参数名前缀
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);
        //循环查找匹配参数
        for (var i = pars.length; i-- > 0;) {
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            //存在则删除
            pars.splice(i, 1);
          }
        }
        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
      }
      return url;
    },
    projectObtain() {
      // 自定义的标头
      const headers = {
        'Sign': generateSign()
      };
      let listcolumnparameter = {}
      listcolumnparameter.appInfoId = "10",
        listcolumnparameter.parentId = "148f7fde-4d1d-4f7f-9052-70fce8f62673"
        console.log(`output->`,headers)
      this.axios.post(getColumnByParentId, { "parentId": "7655a6ea-9869-4c46-97f8-b9e736a0b401" },{ headers }).then(res => {
        this.columnList = res.data.data
        console.log(this.$route.query.title, 'column')
        if (this.$route.query.title) {
          this.columnList.forEach((column, index) => {
            if (column.name == this.$route.query.title) {
              this.switchClass = index + 2
            }
          })
        }
        console.log(this.columnList, 'columnList')
      })
    },
    // scrollTop(){
    //   this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    //   console.log(this.scroll)
    // },
    btnPage() {
      this.$router.push({ path: '/m_index' })
    },
    // app弹出更多功能列表框
    outTag(num, item) {
      console.log(num)
      this.status = item ? item.columnId : null
      console.log(this.status, 'columnId')
      this.switchClass = num
      // Bus.$emit('stateListNe',{type:num});
      // Bus.$emit('jumpRouting', false );
      // if(this.switchClass == 1){
      //   Bus.$emit('loadingSetUp', false );
      // }else{
      //   Bus.$emit('loadingSetUp', true );
      // }
    },
    _isMobile() {

      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      console.log(flag)
      return flag;
    },

    // 移动端app弹出更多功能列表框
    moreAppBtn() {
      this.popupVisible = !this.popupVisible
      this.popupVisibleIf = false
    },
    retrieveAppBtn() {
      this.popupVisibleIf = !this.popupVisibleIf
      this.popupVisible = false
    }
  }

}
</script>

<style>
/* html{
    filter: grayscale(100%) !important;
    -webkit-filter: grayscale(100%) !important;
    -moz-filter: grayscale(100%) !important;
    -ms-filter: grayscale(100%) !important;
    -o-filter: grayscale(100%) !important;

    filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    -webkit-filter: grayscale(1) !important;
    }
    body{-webkit-filter: grayscale(100%) !important;}
    *{
        -moz-filter: grayscale(100%) !important;
        -ms-filter: grayscale(100%) !important;
        -o-filter: grayscale(100%) !important;
        filter: gray !important;
    }

::-webkit-scrollbar {
    position: absolute;
    width: 6px;
    height: 6px;
    margin-left: -10px;
}
::-webkit-scrollbar-thumb {
    cursor: pointer;
    background-color: #898c97;
    background-clip: content-box;
    border-color: transparent;
    border-style: solid;
    border-width: 1px 2px;
    border-radius: 7px;
}
::-webkit-scrollbar-track {
    background-color: transparent;
    border-right: none;
    border-left: none;
} */
/* pc端 */
#app {
  overflow: hidden;
  position: absolute;
  width: 100%;
  background: url("./assets/newsbg-1027.png") no-repeat; 
  /* background: url("./assets/header-list.jpg") no-repeat; */
  background-size: 100%;
  /* background-size:100% 550px; */
  /* background-size:100% 660px; */
  background-color: #F0F3F8;
}

.head_center {
  width: 1200px;
  z-index: 99;
  min-height: 145px;
  margin: 0 auto;
}

.head_logo {
  position: relative;
  z-index: 999;
  text-align: left;
  padding: 55px 0 35px 0;
}

.head_logo img {
  z-index: 999;
  width: 260px;
  height: 81px;
}

.el-tabs__header {
  background-color: #C90304 !important;
  height: 50px !important;
  line-height: 50px;
  margin-bottom: 0 !important;
  /* -moz-box-shadow:0 0 10px rgb(239, 239, 240);
  -webkit-box-shadow:0 0 10px rgb(206, 206, 209);
  box-shadow:0 0 10px rgb(184, 184, 187); */
}

.el-dropdown-menu {
  position: absolute;
  top: 207px !important;
}

.dropdown {
  margin-left: 12px;

}

.navigation_link {
  color: #000;
}

.selected {
  background-color: #ecf5ff;
  color: #66b1ff;
}


.navigation_title {
  display: block;
  float: left;
  color: #ffffff;
  font-size: 16px;
  width: 110px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-family: Microsoft YaHei;
}

.navigation_title:hover {
  color: #000000
}

.navigation_title_if {
  font-weight: bolder;
  display: block;
  float: left;
  color: #000000;
  font-size: 16px;
  width: 110px;
  height: 50px;
  background: #ffffff;
  line-height: 50px;
  text-align: center;
  font-family: Microsoft YaHei;
}

.nav_py /deep/ .el-tabs__item {
  color: #fff !important;
  font-weight: 400;
  font-size: 16px;
}

.nav_py /deep/ .el-tabs__item.is-active {
  color: rgba(0, 0, 0, 1) !important;
  font-weight: 400;
  font-size: 16px;
}

.nav_py /deep/ .el-tabs__content {
  padding: 0;
  background: #C90304 !important;
}


/* 移动端 */
.head_app {
  font-size: 18px;
  width: 100%;
  height: 100vh;
  overflow: auto;
}

.head_app .head_top_app {
  /* height: 4.5rem; */
  line-height: 3.5rem;
  display: flex;
  justify-content: space-between;
  /* background:#6accf7; */
  background-image: url('../src/assets/phone1027.png'); 
  /* background-image: url('../src/assets/phone23.jpg'); */
  background-size: 100% 100%;
  background-repeat:no-repeat;
}

.head_app .logo_app {
  height: 2.5rem;
  padding: 0.5rem 0 0 0.5rem;
}

.head_app .logo_app img {
  height: 95%;
  width: 90%;
}

.head_right_app i {
  font-size: 1.5rem;
  color: #fff;
  margin-right: 1rem;
}

.bounced_app .more_bounced_app {
  top: 5.5rem !important;
  max-height: calc(100vh - 3.5rem);
  overflow: auto;
}

.bounced_app .v-modal {
  top: 5.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue